import React from "react";
import { useLoaderData } from "react-router";

import TableFilters from "./components/TableFilters";
import {
    BannedTeamsProvider,
    useBannedTeamsContext,
} from "./contexts/BannedTeams";
import { BannedTeamsList } from "./types/bannedTeams";

import { store } from "../../../../..";
import Pagination from "../../../../../components/Pagination";
import { PaginationProvider } from "../../../../../contexts/Pagination";
import { globalActions } from "../../../../../features/global/globalSlice";
import { getBannedTeamsByUmpire } from "../../../../../lib/api";
import BannedTable from "./components/BannedTable";

export const loader = async () => {
    const { settings, sites } = store.getState().global;
    const promises = [];
    !sites.length && promises.push(store.dispatch(globalActions.getSites()));
    !settings.length &&
        promises.push(store.dispatch(globalActions.getSettings()));

    const [{ umpires }] = await Promise.all([
        getBannedTeamsByUmpire(),
        ...promises,
    ]);

    return {
        umpires,
    };
};

const BannedList = (): React.ReactNode => {
    const { umpires } = useLoaderData() as {
        umpires: BannedTeamsList[];
    };
    umpires.sort((a, b) =>
        a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1,
    );

    return (
        <PaginationProvider>
            <BannedTeamsProvider initialUmpires={umpires}>
                <TableFilters />
                <BannedTable />
                <Pagination useContext={useBannedTeamsContext} />
            </BannedTeamsProvider>
        </PaginationProvider>
    );
};

export default BannedList;
